export default __webpack_public_path__ + "static/media/2752.277bcb9a.svg";